import { render } from "./chekout.vue?vue&type=template&id=04ad7dd8"
import script from "./chekout.vue?vue&type=script&lang=js"
export * from "./chekout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__